import { AnimatedCounter } from '@/components/arc/animated-counter/animated-counter';
import styles from './KpiCard.module.css';

export interface KpiCardProps {
  label: string;
  value: number;
  /** Text before the number, such as "$". */
  prefix?: string;
  /** Text after the number, such as "%". */
  suffix?: string;
  decimals?: number;
  /** One short line under the value. */
  context: string;
}

/**
 * A KPI tile for fractional values (money, percentages). Arc's `MetricCard` rounds to whole numbers, so this composes
 * the Arc `AnimatedCounter` with the same surface tokens and sits in the same `.kpi-grid` row as `MetricCard`.
 */
export function KpiCard({ label, value, prefix, suffix, decimals = 0, context }: KpiCardProps) {
  return (
    <article className={styles.card}>
      <span className={styles.label}>{label}</span>
      <AnimatedCounter value={value} prefix={prefix} suffix={suffix} decimals={decimals} animateOnView />
      <p className={styles.context}>{context}</p>
    </article>
  );
}
